import { Box } from "@mui/material";

export interface AppLayoutInnerWrapperMobileProps {
  children: React.ReactNode;
}

export function AppLayoutPageWrapperMobile(props: AppLayoutInnerWrapperMobileProps) {
  const { children } = props;

  return (
    <Box height="100%" overflow="scroll">
      {children}
    </Box>
  );
}
